import {
  Container,
  Grid,
  Box,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Loading } from "../../components/shared/loading";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import EmojiObjectsOutlinedIcon from "@material-ui/icons/EmojiObjectsOutlined";
import GradeOutlinedIcon from "@material-ui/icons/GradeOutlined";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import GroupWorkOutlinedIcon from "@material-ui/icons/GroupWorkOutlined";
import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import WidgetsOutlinedIcon from "@material-ui/icons/WidgetsOutlined";
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";
import HeadsetMicOutlinedIcon from "@material-ui/icons/HeadsetMicOutlined";
import { TypingQuote } from "../../components/shared/TypingQuote";
import { HeroParticles } from "../../components/shared/HeroParticles";
import { Reveal } from "../../components/shared/Reveal";
import { CollabCard } from "../../components/shared/CollabCard";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const COLLABS = [
  {
    logo: "/static/scaleme.png",
    name: "ScaleMe.in",
    tagline: "AI Technology Advisory Partner",
    points: [
      "Growth ecosystem for Indian SMEs: expert connections, knowledge, and capital opportunities",
      "AI-based networking systems for events",
      "WhatsApp & voice-based automation for SME engagement",
      "AI-driven lead discovery and matchmaking tools",
      "Internal productivity and communication automations",
    ],
    link: "https://scaleme.in",
  },
  {
    logo: "/static/zaplo.png",
    name: "Ziplo.ai",
    tagline: "Enterprise AI Agent Testing Partner",
    points: [
      "Platform for testing, validating, and governing enterprise AI agents",
      "AI agent reliability and stress testing",
      "Governance, compliance & enterprise-grade observability",
      "Evaluation workflows for LLM-powered systems",
      "Organizational readiness and AI workforce uplift",
    ],
    link: "https://ziplo.ai",
  },
  // CodeSquare Labs - commented out for now
  // {
  //   logo: "/static/csl.png",
  //   name: "CodeSquare Labs",
  //   tagline: "Engineering & Product Development Partner",
  //   points: [
  //     "CSL drives sales, branding, and digital marketing strategies",
  //     "Arawinz builds and maintains websites, mobile apps, backend systems, and cloud infrastructure",
  //     "Full-stack delivery helping CSL's clients scale with stable, secure digital platforms",
  //   ],
  //   link: "https://codesquarelabs.com",
  // },
];

const useStyles = makeStyles((theme) => ({
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  "@keyframes orbDrift": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(14px, -12px) scale(1.12)" },
  },
  "@keyframes orbDriftAlt": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(-16px, 10px) scale(1.08)" },
  },
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(135deg, #1a001a 0%, #2d002d 50%, #1a001a 100%)",
  },
  heroOrb: {
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(60px)",
    pointerEvents: "none",
    zIndex: 0,
  },
  heroOrbOne: {
    width: 340,
    height: 340,
    top: "-16%",
    right: "6%",
    background:
      "radial-gradient(circle, rgba(199,125,199,0.35), transparent 68%)",
    animation: "$orbDrift 9s ease-in-out infinite",
  },
  heroOrbTwo: {
    width: 300,
    height: 300,
    bottom: "-22%",
    left: "2%",
    background:
      "radial-gradient(circle, rgba(155,59,155,0.3), transparent 68%)",
    animation: "$orbDriftAlt 11s ease-in-out infinite",
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroEyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "0.62rem",
    fontWeight: 700,
    letterSpacing: "2.4px",
    textTransform: "uppercase",
    color: "#e0b8e0",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(199,125,199,0.35)",
    borderRadius: 30,
    padding: "6px 16px",
    marginBottom: 18,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) both",
    "&::before": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "#c77dc7",
      boxShadow: "0 0 10px #c77dc7",
    },
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  section: {
    padding: "40px 0",
    [theme.breakpoints.down('sm')]: {
      padding: "28px 0",
    },
  },
  sectionAlt: {
    padding: "40px 0",
    background: "#fafafa",
    [theme.breakpoints.down('sm')]: {
      padding: "28px 0",
    },
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  contentCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    },
  },
  contentText: {
    fontSize: "0.85rem",
    color: "#444444",
    lineHeight: 1.7,
    "& p": {
      marginBottom: 12,
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      color: "#4c004c",
      marginTop: 16,
      marginBottom: 8,
      fontSize: "1rem",
    },
    "& ul, & ol": {
      paddingLeft: 20,
      marginBottom: 12,
    },
    "& li": {
      marginBottom: 6,
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    textAlign: "center",
  },
  quoteIcon: {
    fontSize: 28,
    color: "rgba(255, 255, 255, 0.15)",
    display: "block",
    margin: "0 auto 10px",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
  valueCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "20px",
    height: "100%",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    transition: "all 0.4s cubic-bezier(0.22,1,0.36,1)",
    textAlign: "center",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 16px 36px rgba(107, 27, 107, 0.14)",
    },
  },
  valueIconTile: {
    width: 40,
    height: 40,
    borderRadius: 11,
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #6b1b6b, #9b3b9b)",
    color: "#ffffff",
    boxShadow: "0 8px 18px rgba(107, 27, 107, 0.28)",
    "& svg": { fontSize: 22 },
  },
  // ── Story stat rail ──
  // Sticky lives on this wrapper (a direct child of the stretched grid
  // item) so the rail follows the reader alongside the taller story card.
  storyStatCol: {
    position: "sticky",
    top: 96,
    [theme.breakpoints.down('sm')]: {
      position: "static",
    },
  },
  storyStatRail: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "14px",
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    },
  },
  storyStatTile: {
    background: "#ffffff",
    borderRadius: 14,
    padding: "16px 18px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    border: "1px solid rgba(76,0,76,0.06)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    transition: "all 0.35s cubic-bezier(0.22,1,0.36,1)",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 12px 28px rgba(107, 27, 107, 0.14)",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "14px 12px",
      gap: "10px",
    },
  },
  storyStatIcon: {
    width: 42,
    height: 42,
    minWidth: 42,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #6b1b6b, #9b3b9b)",
    color: "#ffffff",
    boxShadow: "0 8px 18px rgba(107, 27, 107, 0.28)",
    "& svg": { fontSize: 22 },
    [theme.breakpoints.down('xs')]: {
      width: 36,
      height: 36,
      minWidth: 36,
      "& svg": { fontSize: 19 },
    },
  },
  storyStatValue: {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#4c004c",
    lineHeight: 1.2,
    [theme.breakpoints.down('xs')]: {
      fontSize: "0.95rem",
    },
  },
  storyStatLabel: {
    fontSize: "0.66rem",
    fontWeight: 600,
    color: "#888888",
    textTransform: "uppercase",
    letterSpacing: "1.1px",
    marginTop: 2,
  },
  valueTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: 8,
  },
  valueText: {
    fontSize: "0.78rem",
    color: "#666666",
    lineHeight: 1.5,
  },
  // ── Closing CTA band ──
  ctaBand: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 18,
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    padding: "38px 30px",
    textAlign: "center",
    boxShadow: "0 16px 44px rgba(76,0,76,0.25)",
    "&::before": {
      content: '""',
      position: "absolute",
      width: 320,
      height: 320,
      borderRadius: "50%",
      top: -160,
      left: -100,
      background:
        "radial-gradient(circle, rgba(199,125,199,0.3), transparent 70%)",
      pointerEvents: "none",
    },
  },
  ctaBandTitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#ffffff",
    marginBottom: 8,
    letterSpacing: "-0.01em",
  },
  ctaBandSub: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.72)",
    maxWidth: 440,
    margin: "0 auto 20px",
    lineHeight: 1.6,
  },
  ctaBandBtn: {
    position: "relative",
    zIndex: 1,
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    background: "#ffffff",
    color: "#4c004c",
    fontSize: "0.8rem",
    fontWeight: 600,
    borderRadius: 11,
    padding: "10px 24px",
    textDecoration: "none",
    boxShadow: "0 8px 22px rgba(0,0,0,0.2)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#4c004c",
      textDecoration: "none",
    },
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 14px 30px rgba(0,0,0,0.3)",
    },
    "& svg": {
      fontSize: 16,
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "&:hover svg": { transform: "translateX(4px)" },
  },
}));

export const AboutUs = () => {
  const classes = useStyles();
  const [data, setData] = useState();
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 6);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
    Axios.post("/api/select_aboutus", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setData(ReactHtmlParser(res.data.data.description));
      }
    });
  };

  const storyStats = [
    { value: "Est. 2018", label: "Founded", icon: FlagOutlinedIcon },
    { value: "15+", label: "Products and projects", icon: WidgetsOutlinedIcon },
    { value: "3", label: "Industry awards", icon: EmojiEventsOutlinedIcon },
    { value: "24x7", label: "Support", icon: HeadsetMicOutlinedIcon },
  ];

  const values = [
    {
      title: "Innovation",
      text: "Pushing boundaries with new technology",
      icon: EmojiObjectsOutlinedIcon,
    },
    {
      title: "Excellence",
      text: "Delivering quality that exceeds expectations",
      icon: GradeOutlinedIcon,
    },
    {
      title: "Integrity",
      text: "Building trust through transparent partnerships",
      icon: VerifiedUserOutlinedIcon,
    },
    {
      title: "Collaboration",
      text: "Working together to achieve shared success",
      icon: GroupWorkOutlinedIcon,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>

      {isloading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <HeroParticles id="aboutus-hero-particles" />
            <Box className={`${classes.heroOrb} ${classes.heroOrbOne}`} />
            <Box className={`${classes.heroOrb} ${classes.heroOrbTwo}`} />
            <Box className={classes.heroContent}>
              <span className={classes.heroEyebrow}>Since 2018</span>
              <Typography className={classes.heroTitle}>
                About Us
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                Crafting Excellence Through Unique IT Services - Transforming Ideas Into Powerful Digital Solutions Since 2018
              </Typography>
            </Box>
          </Box>

          {/* Story Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Story & Vision
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Learn about our journey, values, and the drive behind our innovations
                  </Typography>
                </Box>
              </Reveal>

              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Box className={classes.storyStatCol}>
                    <Reveal delay={80}>
                      <Box className={classes.storyStatRail}>
                        {storyStats.map((stat, index) => {
                          const StatIcon = stat.icon;
                          return (
                            <Box className={classes.storyStatTile} key={index}>
                              <Box className={classes.storyStatIcon}>
                                <StatIcon />
                              </Box>
                              <Box>
                                <Typography className={classes.storyStatValue}>
                                  {stat.value}
                                </Typography>
                                <Typography className={classes.storyStatLabel}>
                                  {stat.label}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Reveal>
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Reveal delay={160}>
                    <Box className={classes.contentCard}>
                      <Box className={classes.contentText}>
                        {data}
                      </Box>
                    </Box>
                  </Reveal>
                </Grid>
              </Grid>
            </Container>
          </Box>

          {/* Collaborations Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Reveal>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Collaborations
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Strategic partnerships powering innovation, AI transformation, and scalable engineering
                  </Typography>
                </Box>
              </Reveal>

              <Grid container spacing={3} justifyContent="center">
                {COLLABS.map((collab, i) => (
                  <Grid item xs={12} md={6} key={collab.name}>
                    <Reveal delay={i * 120}>
                      <CollabCard
                        logo={collab.logo}
                        name={collab.name}
                        tagline={collab.tagline}
                        points={collab.points}
                        link={collab.link}
                      />
                    </Reveal>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* Values Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Core Values
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    The principles that guide everything we do
                  </Typography>
                </Box>
              </Reveal>

              <Grid container spacing={3}>
                {values.map((value, index) => {
                  const ValueIcon = value.icon;
                  return (
                    <Grid item xs={6} sm={6} md={3} key={index}>
                      <Reveal delay={index * 100}>
                        <Box className={classes.valueCard}>
                          <Box className={classes.valueIconTile}>
                            <ValueIcon />
                          </Box>
                          <Typography className={classes.valueTitle}>
                            {value.title}
                          </Typography>
                          <Typography className={classes.valueText}>
                            {value.text}
                          </Typography>
                        </Box>
                      </Reveal>
                    </Grid>
                  );
                })}
              </Grid>
            </Container>
          </Box>

          {/* CEO Quote Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box className={classes.quoteSection}>
                  <FormatQuoteIcon className={classes.quoteIcon} />
                  <TypingQuote
                    text={`"At Arawinz, creativity and commitment sit at the heart of everything we build, and it shows in the results we deliver. We hold ourselves to a high standard, work hard to understand what each client actually needs, and build smarter, more connected products together."`}
                    className={classes.quoteText}
                  />
                  <Typography className={classes.quoteAuthor}>
                    - Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Reveal>
            </Container>
          </Box>

          {/* Closing CTA */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box className={classes.ctaBand}>
                  <Typography className={classes.ctaBandTitle}>
                    Want to build something with us?
                  </Typography>
                  <Typography className={classes.ctaBandSub}>
                    Tell us what your business needs and we will figure it out
                    together.
                  </Typography>
                  <Link to="/get-in-touch" className={classes.ctaBandBtn}>
                    Get in Touch <ArrowForwardIcon />
                  </Link>
                </Box>
              </Reveal>
            </Container>
          </Box>
        </>
      )}
    </div>
  );
};
